// import { onUnmounted } from 'vue' // Больше не используется
import type { Ref } from 'vue'
import { consola } from 'consola'
import { 
  createExpirationTimer,
  type ExpirationTimer, 
} from '../lib/timerUtils'
import type { TokenExpirationInfo } from '@entities/order'

/**
 * Composable для управления таймерами оплаты
 */
export function usePaymentTimer() {
  // Таймер для отслеживания истечения токена
  const expirationTimer: ExpirationTimer = createExpirationTimer()
  const logger = consola.withTag('payment-timer')

  /**
   * Запускает таймер для отслеживания истечения токена
   */
  function startExpirationTimer(
    tokenExpiration: Ref<TokenExpirationInfo | null>,
    hasUnpaidOrder: Ref<boolean>,
    onExpired: () => void,
    onTimeUpdate?: (time: number) => void, // Добавляем колбэк для обновления времени
  ): void {
    if (expirationTimer.isActive()) {
      logger.warn('Timer already running, skipping start')
      return
    }
    
    if (!tokenExpiration.value) {
      logger.warn('No token expiration info, skipping timer start')
      return
    }
    
    logger.info('Starting expiration timer', {
      expiresAt: tokenExpiration.value.expiresAt,
      hasUnpaidOrder: hasUnpaidOrder.value,
    })
    expirationTimer.start(tokenExpiration, hasUnpaidOrder, () => {
      logger.info('Token expiration callback triggered')
      onExpired()
    }, onTimeUpdate)
  }
  
  /**
   * Останавливает таймер истечения токена
   */
  function stopExpirationTimer(): void {
    if (!expirationTimer.isActive()) return
    logger.info('Stopping expiration timer')
    expirationTimer.stop()
  }

  /**
   * Перезапускает таймер истечения токена
   */
  function restartExpirationTimer(
    tokenExpiration: Ref<TokenExpirationInfo | null>,
    hasUnpaidOrder: Ref<boolean>,
    onExpired: () => void,
  ): void {
    logger.info('Restarting expiration timer')
    expirationTimer.restart(tokenExpiration, hasUnpaidOrder, onExpired)
  }

  /**
   * Проверяет, активен ли таймер
   */
  function isTimerActive(): boolean {
    return expirationTimer.isActive()
  }

  // НЕ останавливаем таймер автоматически при размонтировании
  // Таймер должен работать независимо от жизненного цикла компонентов
  // onUnmounted(() => {
  //   stopExpirationTimer()
  // })

  return {
    // Actions
    startExpirationTimer,
    stopExpirationTimer,
    restartExpirationTimer,
    isTimerActive,
  }
}